<template>
    <form @submit.prevent="submitForm">
        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(submitForm)" :id="formId">
                <ValidationProvider vid="name" :name="$t('user_invite.name')" rules="required" v-slot="{ errors }" class="flex-grow-1">
                    <div class="form-group">
                        <label for="input-name" class="form-control-label">{{ $t('user_invite.name') }} *</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                        <span class="input-group-text">
                            <icon name="user"></icon>
                        </span>
                            </div>
                            <input
                                type="text"
                                v-model="formValues.name"
                                class="form-control"
                                id="input-name"
                                :placeholder="$t('user_invite.fill_in_name')"
                                :class="{ 'is-invalid': errors.length }"
                                required
                            />
                            <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                        </div>
                    </div>
                </ValidationProvider>

                <ValidationProvider vid="password" :name="$t('user_invite.password')" rules="required" v-slot="{ errors }" class="flex-grow-1">
                    <div class="form-group mb-0">
                        <label for="input-password" class="form-control-label">{{ $t('user_invite.password') }} *</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                            <span class="input-group-text">
                                <icon name="key"></icon>
                            </span>
                            </div>
                            <input
                                :type="passwordVisible ? 'text' : 'password'"
                                v-model="formValues.password"
                                class="form-control"
                                id="input-password"
                                :placeholder="$t('user_invite.fill_in_password')"
                                :class="{ 'is-invalid': errors.length }"
                                required
                            />
                            <div class="input-group-append">
                                <span class="input-group-text" @click="passwordVisible = !passwordVisible" style="cursor: pointer;">
                                    <icon :name="passwordVisible ? 'eye-slash' : 'eye'" style="fill: black !important;"></icon>
                                </span>
                            </div>
                            <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                        </div>
                    </div>
                </ValidationProvider>
            </form>
        </ValidationObserver>
    </form>
</template>

<script setup>

    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { ref } from 'vue';

    const emit = defineEmits(['submit']);
    defineProps({
        formId: {
            type: String,
            default: null,
        },
    });

    const formValues = ref({
        name: '',
        password: '',
    });
    const passwordVisible = ref(false);

    function submitForm() {
        emit('submit', formValues.value);
    }
</script>
